import React, { memo } from 'react';
import { Settings } from 'lucide-react';

interface SyncControlsProps {
  showSyncStatus: boolean;
  onToggleSyncStatus: () => void;
  onForceResync: () => void;
  isLoading: boolean;
  isSyncing: boolean;
  // View-aware customizer controls
  currentView?: 'card' | 'list';
  onToggleCardCustomizer?: () => void;
  showCardCustomizer?: boolean;
  onToggleListCustomizer?: () => void;
  showListCustomizer?: boolean;
}

const SyncControls = memo<SyncControlsProps>(({ 
  showSyncStatus, 
  onToggleSyncStatus, 
  onForceResync, 
  isLoading, 
  isSyncing,
  currentView,
  onToggleCardCustomizer,
  showCardCustomizer = false,
  onToggleListCustomizer,
  showListCustomizer = false
}) => {
  return (
    <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
      <div className="flex items-center space-x-2">
        <button
          onClick={onToggleSyncStatus}
          className={`px-3 py-1 text-sm font-medium rounded-md transition-colors duration-200 hover:shadow-md ${
            showSyncStatus
              ? 'bg-blue-100 text-blue-800 border border-blue-300'
              : 'bg-gray-100 text-gray-600 border border-gray-300 hover:bg-gray-200'
          }`}
        >
          Sync Status
        </button>
      </div>
      {/* Customization buttons moved next to ViewToggle in Taskpane header */}
      <button
        onClick={onForceResync}
        disabled={isLoading || isSyncing}
        className="bg-orange-600 hover:bg-orange-700 disabled:bg-orange-400 text-white px-3 py-1 text-sm font-medium rounded-md hover:shadow-md"
      >
        Resync
      </button>
    </div>
  );
});

SyncControls.displayName = 'SyncControls';

export default SyncControls;
